import SvgIcon from '@/components/common/SvgIcon'

export const IconLogout = () => {
    return (
        <SvgIcon viewBox="0 0 18 18">
            <path fill="#FFF" fillRule="nonzero" d="M10.21 13.29a.996.996 0 0 1-1.41 0L5.21 9.7a.996.996 0 0 1 0-1.41L8.8 4.7a.996.996 0 1 1 1.41 1.41L8.33 8H17c.55 0 1 .45 1 1s-.45 1-1 1H8.33l1.88 1.88c.39.39.38 1.03 0 1.41zM2 0h14a2 2 0 0 1 2 2v3c0 .55-.45 1-1 1s-1-.45-1-1V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-2c0-.55.45-1 1-1s1 .45 1 1v3c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0z"/>
        </SvgIcon>
    )
}
